import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _cloneDeep from "lodash/cloneDeep";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.map.js";
import { EXPERIMENTS_METADATA_CREATE } from 'redux/actionTypes/experiments';
import { SAMPLES_UPDATE } from 'redux/actionTypes/samples';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { metadataNameToKey } from 'utils/data-management/metadataUtils';
import { METADATA_DEFAULT_VALUE } from 'redux/reducers/experiments/initialState';
import { loadBackendStatus } from '../backendStatus';
var createMetadataTrack = function createMetadataTrack(name, experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var experiment, _getState, samples, metadataKey, newExperiment;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            experiment = getState().experiments[experimentId];
            _getState = getState(), samples = _getState.samples;
            metadataKey = metadataNameToKey(name);
            newExperiment = _cloneDeep(experiment);
            newExperiment.metadataKeys.push(metadataKey);
            _context.prev = 5;
            _context.next = 8;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/metadataTracks/").concat(metadataKey), {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 8:
            dispatch({
              type: EXPERIMENTS_METADATA_CREATE,
              payload: {
                experimentId: experimentId,
                key: metadataKey
              }
            });
            _context.next = 11;
            return Promise.all(experiment.sampleIds.map(function (sampleUuid) {
              return dispatch({
                type: SAMPLES_UPDATE,
                payload: {
                  sampleUuid: sampleUuid,
                  sample: {
                    metadata: _defineProperty({}, metadataKey, samples[sampleUuid].metadata[metadataKey] || METADATA_DEFAULT_VALUE)
                  }
                }
              });
            }));
          case 11:
            _context.next = 13;
            return dispatch(loadBackendStatus(experimentId));
          case 13:
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            handleError(_context.t0, endUserMessages.ERROR_SAVING);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 15]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default createMetadataTrack;